import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3462 41.3461H0.845529C0.378611 41.3461 0 40.9609 0 40.4858V9.51417C0 9.03906 0.378611 8.65381 0.845529 8.65381H16.3462V41.3461Z",
			fill: "#464655"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.6562 8.6543H16.3462V41.3466H33.6562V8.6543Z",
			fill: "#FFE15A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.1544 41.3461H33.6538V8.65381H49.1544C49.6214 8.65381 50 9.03906 50 9.51417V40.4858C50 40.9611 49.6214 41.3461 49.1544 41.3461Z",
			fill: "#CD343C"
		})
	]
});
const ForwardRef = forwardRef(SvgBeFlag);
export { ForwardRef as ReactComponent };
